const LayerGroup = () => <div className="layer-group"></div>;
LayerGroup.displayName = 'LayerGroup';
export default LayerGroup;
